import { ccpProvider } from 'core/CcpProvider'

export default class Ccp {

  async fetchMessages(conversationUid) {
    const [response] = await ccpProvider.api.ccp.fetchMessages(conversationUid, true)
    return response
  }

  monitoring(data) {
    return ccpProvider.api.ccp.monitoring(data)
  }
}
